import styled from '@emotion/styled';
import { B50 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var BackgroundFade = styled.div(function (props) {
  return {
    backgroundColor: props.isUnseen ? "var(--ds-background-accent-blue-subtler, ".concat(B50, ")") : 'transparent',
    transition: 'background-color 2s'
  };
});